import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { environment } from 'src/environments/environment';
interface incub {
  id: string;
  incubatorName: string;
}
@Component({
  selector: 'app-resources-page',
  templateUrl: './resources-page.component.html',
  styleUrls: ['./resources-page.component.css'],
})
export class ResourcesPageComponent implements OnInit {
  searchForm: FormGroup;
  private listApi = environment.url + environment.homenewsletterList;
  private nameListApi = environment.url + environment.incubatorNameList;
  private infraListApi = environment.url + environment.infraList;
  /**
   * Constructs a new instance of the ResourcesPageComponent.
   * @param makeapi The API service to make API calls.
   * @param http The HTTP client to make API calls.
   * @param router The router service to navigate to other pages.
   * @param fb The form builder to create the search form.
   */
  constructor(
    private makeapi: ApiService,
    private http: HttpClient,
    private router: Router,
    private fb: FormBuilder
  ) {
    /**
     * The form group for the search form.
     * Contains the following fields: incubatorName, title, and newsletterDate.
     */
    this.searchForm = this.fb.group({
      incubatorName: [''],
      title: [''],
      newsletterDate: [''],
    });
  }
  resourceallData;
  /**
   * Initializes the component.
   * Calls the following methods to fetch the required data:
   * - `incubatorNameApi`: Fetches the list of incubators from the API.
   * - `newsletterlistApi`: Fetches the list of newsletters from the API.
   * - `infrastructureList`: Fetches the list of infrastructure facilities from the API.
   * - `getResourceData`: Fetches the list of resources from the API.
   */
  ngOnInit(): void {
    this.incubatorNameApi();
    this.newsletterlistApi();
    this.infrastructureList();
    this.getResourceData();
  }
  infrastructureValue = [{}];
  /**
   * Fetches the list of infrastructure facilities from the API.
   * Subscribes to the API response and updates the infrastructureValue
   * with the facilities data if available.
   */
  infrastructureList() {
    // Make a GET request to the infrastructure list API
    this.makeapi
      .method(this.infraListApi, '', 'getunauth')
      .subscribe((data) => {
        // Check if the response includes incubators facilities
        if (data.incubatorsFactilities) {
          // Update the infrastructureValue with the received facilities data
          this.infrastructureValue = data.incubatorsFactilities;
        }
      });
  }
  viewmore() {}
  namePush = [];
  /**
   * Retrieves the list of incubator names from the server.
   * Saves the list in the `incubatorNameList` property and
   * initializes the incubator name filter.
   */
  incubatorNameApi() {
    // Make a POST request to the incubator name list API
    this.makeapi
      .method(this.nameListApi, '', 'postunauth')
      .subscribe((data) => {
        // Save the list of incubator names
        this.incubatorNameList = data;
        // Initialize the incubator name filter
        this.filterIncubetor();
      });
  }

  list: any = {};
  newsLetterList = [];
  newnewsLetterList;
  /**
   * Initializes the list object and calls the API to fetch the newsletters.
   * Resets the search parameters and invokes the list function to update the newsletter list.
   */
  newsletterlistApi() {
    // Initialize an empty list object to reset search parameters
    this.list = {};

    // Call the list function to fetch newsletters based on the current parameters
    this.listFun();
  }
  /**
   * Calls the API to fetch the list of newsletters based on the search parameters.
   * Updates the component's data with the API response.
   * @param list - The object containing the search parameters.
   * @returns An observable containing the response from the API.
   */
  listFun() {
    return this.makeapi
      .method(this.listApi, this.list, 'postunauth')
      .subscribe((data) => {
        // Update the component's data with the API response
        this.newsLetterList = data.responsemodelList;
      });
  }
  /**
   * Destroys the component and unsubscribes from any subscriptions.
   * This prevents memory leaks when the component is destroyed.
   */
  ngOnDestroy() {
    // Unsubscribe from any subscriptions
    this._onDestroy.next();
    // Complete the subject
    this._onDestroy.complete();
  }
  @ViewChild('singleSelect', { static: true }) singleSelect: MatSelect;

  protected incubatorNameList: incub[] = [];
  public incubatorName: FormControl = new FormControl();
  public incubatorFilterCtrl: FormControl = new FormControl();
  public incubatorListValue = new ReplaySubject(1);
  protected _onDestroy = new Subject();
  /**
   * Sets the initial value of the incubator select control and filters the list
   * of incubator names based on the user's input.
   * Subscribes to the value changes of the filter control and calls the
   * filterBanks function whenever the value changes.
   */
  filterIncubetor() {
    // Set the initial value of the incubatorName select control
    this.incubatorName.setValue(this.incubatorNameList[1]);

    // Set the initial value of the incubator list
    this.incubatorListValue.next(this.incubatorNameList.slice());

    // Subscribe to the value changes of the filter control
    // When the value changes, call the filterBanks function
    this.incubatorFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBanks();
      });
  }
  /**
   * Filters the list of incubator names based on the current value of the filter control.
   * Updates the incubator list value with the filtered results.
   * If no search term is provided, the full list is returned.
   */
  protected filterBanks() {
    if (!this.incubatorNameList) {
      // If the incubator name list is not available, return immediately.
      return;
    }

    // Get the current search term from the filter control.
    let search = this.incubatorFilterCtrl.value;

    // If no search term is provided, return the full list of incubator names.
    if (!search) {
      this.incubatorListValue.next(this.incubatorNameList.slice());
      return;
    } else {
      // Convert the search term to lowercase for case-insensitive comparison.
      search = search.toLowerCase();
    }

    // Filter the incubator name list based on the search term and update the list value.
    this.incubatorListValue.next(
      this.incubatorNameList.filter(
        (val) => val.incubatorName.toLowerCase().indexOf(search) > -1
      )
    );
  }
  resourceData;
  /**
   * Fetches resource data from the local JSON file and updates the resourceData variable.
   * Utilizes the HttpClient to make an HTTP GET request to the specified JSON file.
   */
  getResourceData() {
    // Make HTTP GET request to fetch data from the JSON file
    this.http.get<any>('assets/json/resource.json').subscribe((data) => {
      // Assign the fetched data to the resourceData variable
      this.resourceData = data;
    });
  }

  /**
   * Navigates to the newsletter details page.
   */
  newsletterdetails() {
    // Redirect to the newsletters details page
    this.router.navigateByUrl('/newsletters-details');
  }
  /**
   * Opens the given link in a new tab.
   * @param link The link to open.
   */
  linkclick(link: string) {
    window.open(link, '_blank');
  }
}
